<template>
  <div v-if="smAndDown && questionsAndAnswers.results.length > 0">
    <p class="text-h6 mx-1">{{ topic.title }}</p>

    <div class="pb-6 px-2 full-width">
      <template v-for="(item, index) in questionsAndAnswers.results">
        <div class="d-flex full-width" :key="'row_' + index">
          <div class="mx-0">
            <span class="text-subtitle-1 text-wrap font-weight-bold mt-3 mr-5 mb-0 pb-0">{{ item.questionTitle }}</span>
            <span v-if="item.questionText" class="text-body-2">{{ item.questionText }}</span>
          </div>
        </div>
        <v-divider :key="'div__' + index" class="mb-2"></v-divider>
        <div v-if="item.comment" class="d-flex text-body-2" :key="'row_comment__' + index">
          <div class="d-flex align-center" style="width: 100px">{{ $t('bf.comment') }}</div>
          <div class="d-flex flex-grow-1 justify-end">{{ item.comment }}</div>
        </div>
        <div :key="'row___' + index" class="d-flex full-width pb-2 text-body-2">
          <div class="d-flex align-center" style="width: 100px">{{ $t('bf.assessment') }}</div>
          <div class="d-flex font-weight-bold flex-grow-1 justify-end">{{ item.answer }}</div>
          <div class="d-flex font-weight-bold px-2 ml-2 rounded justify-end" :style="getRatingStyle(item.answer, item.answerDescriptionScale, true, true)">
            <!-- scale value description not required since scale is displayed below-->
            <!--          <p class="caption ma-1">{{ item.answerDescription }}</p>-->
          </div>
        </div>
        <div :key="'image_row' + index" v-if="item.images.length > 0">
          <div class="full width d-flex flex-wrap">
            <div v-for="image in item.images" :key="image.id" class="mr-3 mt-2">
              <result-image :filename="image"></result-image>
            </div>
          </div>
        </div>
        <div :key="'specialScale_' + index" v-if="item.answerDescriptionScale.length > 0" class="mt-2" style="overflow-x: scroll; width: 100%">
          <div class="full-width d-flex flex-wrap justify-start">
            <div v-for="(scale, ind) in item.answerDescriptionScale" :key="'scale_' + ind" class="d-flex">
              <div class="d-flex legend-box" :style="getScaleRatingStyle(scale, true, true)"></div>
              <div class="d-flex caption mr-4">
                {{ scale.rating && scale.rating.answer }}<span v-if="scale.ratingDescription != ''">=</span>{{ scale.ratingDescription }}
              </div>
            </div>
          </div>
        </div>
        <v-divider :key="'div_' + index" class="mb-3"></v-divider>
      </template>
    </div>
  </div>

  <!--- desktop view --->
  <div v-else-if="mdAndUp && questionsAndAnswers.results.length > 0">
    <p class="font-weight-bold title ma-2">{{ topic.title }}</p>
    <v-divider></v-divider>

    <v-simple-table class="pb-6">
      <template v-slot:default>
        <thead>
          <tr class="">
            <th class="text-left topic-column">{{ $t('bf.topic') }}</th>
            <th class="text-left width-fit-content comment-column">{{ $t('bf.comment') }}</th>
            <th class="text-center assessment-column">{{ $t('bf.assessment') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in questionsAndAnswers.results">
            <tr :key="index + '!'">
              <td :style="{ 'border-bottom': item.images.length > 0 ? 'none' : '' }">
                <p class="body-1 ma-1">{{ item.questionTitle }}</p>
                <p class="caption ma-1">{{ item.questionText }}</p>
              </td>
              <td :style="{ 'border-bottom': item.images.length > 0 ? 'none' : '' }">
                <p class="caption ma-1">{{ item.comment }}</p>
              </td>
              <td class="text-center" :style="{ 'border-bottom': item.images.length > 0 ? 'none' : '' }">
                <span class="font-weight-bold px-2 mr-2" :style="getRatingStyle(item.answer, item.answerDescriptionScale, true, true)">
                  <!-- scale value description not required since scale is displayed below-->
                  <!--          <p class="caption ma-1">{{ item.answerDescription }}</p>-->
                </span>
                <span class="font-weight-bold"> {{ item.answer ? item.answer : $t('bf.noAssessment') }}</span>
                <!-- scale value description not required since scale is displayed below-->
                <!--          <p class="caption ma-1">{{ item.answerDescription }}</p>-->
              </td>
            </tr>

            <tr :key="index + '_image'" v-if="item.images.length > 0">
              <td colspan="3" style="border-top: none">
                <div class="full width d-flex flex-wrap">
                  <div v-for="image in item.images" :key="image.id" class="mr-3 mt-2">
                    <result-image :filename="image"></result-image>
                  </div>
                </div>
              </td>
            </tr>

            <!-- rating scale value description -->
            <tr :key="index + '_'" v-if="item.answerDescriptionScale.length > 0 && showLabels">
              <td colspan="3" class="text-right">
                <div class="full-width justify-end d-flex flex-wrap mb-5">
                  <div v-for="(scale, ind) in item.answerDescriptionScale" :key="'scale_' + ind" class="d-flex">
                    <div class="d-flex legend-box" :style="getScaleRatingStyle(scale, true, true)"></div>
                    <div class="d-flex caption mr-2">
                      {{ scale.rating && scale.rating.answer }}<span v-if="scale.ratingDescription != ''">=</span>{{ scale.ratingDescription }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import commonMixin from '@/mixins/common';
import ResultImage from '@/modules/begleitfahrt/views/result/ResultImage.vue';

export default {
  name: 'ResponsiveResultTable',
  components: { ResultImage },
  mixins: [commonMixin],
  props: {
    questionsAndAnswers: Object,
    topic: Object,
    showLabels: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      coloredDefaultScale: false,
    };
  },
  methods: {
    getScaleRatingStyle(scale, applyColors, background = false) {
      if (background) {
        return applyColors && `background:${scale.rating && scale.rating.color}`;
      }
      return applyColors && `border-bottom: 4px solid ${scale.rating && scale.rating.color}`;
    },
    getRatingStyle(rating, ratings, applyColors, background = false) {
      const ratingObj = ratings.find((r) => r.rating.answer == rating);
      if (background && ratingObj) {
        return applyColors && `background:${ratingObj.rating.color}`;
      }
      return applyColors && ratingObj && `border-bottom: 4px solid ${ratingObj.rating.color}`;
    },
  },
};
</script>
<style scoped>
.assessment-column {
  width: 100px;
  text-align: center;
}

.topic-column {
  width: 400px;
}
.xs-value-column {
  width: 70%;
}

.theme--dark .legend {
  color: #f0f0f0 !important;
}

.theme--light .legend {
  color: #202020 !important;
}
.legend-box {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  margin: 5px 5px 0 0;
}

.theme--dark tbody > tr:hover {
  background-color: #333333 !important;
}
</style>
